// extracted by mini-css-extract-plugin
export default {"dashboard":"common_dashboard__Hfpw6","time":"common_time__tZi4T","capitalizeFirstLetter":"common_capitalizeFirstLetter__GUyk-"};